export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: 'primary',
          text: 'NEW'
        }
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Data Taman',
        to: '/taman',
        icon: 'cil-folder-open',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Data Pohon',
        to: '/pohon',
        icon: 'cil-folder-open',
      },       
      {
        _name: 'CSidebarNavItem',
        name: 'Informasi Pohon',
        to: '/informasi',
        icon: 'cil-folder-open',
      }, 
       
      {
        _name: 'CSidebarNavItem',
        name: 'Data Pengaduan',
        to: '/pengaduan',
        icon: 'cil-folder-open',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Data Artikel',
        to: '/artikel',
        icon: 'cil-folder-open',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Data Foto',
        to: '/foto',
        icon: 'cil-folder-open',
      }, 
      {
        _name: 'CSidebarNavItem',
        name: 'Data User',
        to: '/user',
        icon: 'cil-folder-open',
      },
            
      {
        _name: 'CSidebarNavTitle',
        name: 'Setting',
        _children: ['Setting']
      },
      
      {
        _name: 'CSidebarNavItem',
        name: 'Profilku',
        to: '/profilku',
        icon: 'cil-folder-open'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Ganti Password',
        to: '/gantipassword',
        icon: 'cil-folder-open',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logout',
        to: '/logout',
        icon: 'cil-account-logout',
      },
    ]
  }
]